export const AVATAR_SOURCE_READY = "AVATAR_SOURCE_READY";
export const AVATAR_CROP_UPDATE = "AVATAR_CROP_UPDATE";
export const AVATAR_CROP_READY = "AVATAR_CROP_READY";
export const AVATAR_RESET = "AVATAR_RESET";
export const avatarSourceReady = () => ({ type: AVATAR_SOURCE_READY });
export const avatarCropUpdate = crop => ({ type: AVATAR_CROP_UPDATE, crop });
export const avatarCropReady = () => ({ type: AVATAR_CROP_READY });
export const avatarReset = () => ({ type: AVATAR_RESET });
